import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Navbar from "./Navbar"; // Assuming you have a Navbar component
import url from "../../function/url"; // Update with the correct path to your `url` helper
import { FaCheck, FaTimes, FaArrowRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import "./Modal.css";
import Swal from "sweetalert2";

const ManagerBlacklistRequests = () => {
  const [inProgressRequests, setInProgressRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;
  
    const [requests, setRequests] = useState([]);

    const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
          });

  // Fetch "In Progress" requests assigned to the manager
  useEffect(() => {
    const logId = Cookies.get("log_id"); // Replace with your actual manager ID if stored differently

    if (!logId) {
      setError("User not logged in or session expired. Please log in again.");
      setLoading(false);
      return;
    }

    axios
      .get(`${url.path}/manager-dashboard-blacklist/`, {
        params: { log_id: logId },
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
        // withCredentials: true,
      })
      .then((response) => {
        setInProgressRequests(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching requests:", error);
        setError("Failed to fetch requests.");
        setLoading(false);
      });
  }, []);

  // Handle approval of a blacklist request
  const handleApprove = (request) => {
    axios
      .post(`${url.path}/approve-manager-blacklist-request/`, {
        request_id: request.id,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request approved!",
        });
        setInProgressRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === request.id ? { ...r, manager_status: "Approved" } : r
          )
        );
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error approving request",
        });
        console.error("Approval failed:", error);
      });
  };
  
  const handleReject = () => {
    if (!rejectionReason) {
      Toast.fire({
        icon: "warning",
        title: "Please provide a reason for rejection",
      });
      
      return;
    }
  
    axios
      .post(`${url.path}/reject-manager-blacklist-request/`, {
        request_id: selectedRequest.id,
        rejection_reason: rejectionReason,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request rejected!",
        });
        
        setInProgressRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === selectedRequest.id
              ? { ...r, manager_status: "Rejected" }
              : r
          )
        );
        setIsModalOpen(false); // Close modal
        setRejectionReason(""); // Reset rejection reason
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error rejecting request",
        });
        
        console.error("Rejection failed:", error);
      });
  };
  
  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#documentTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = requests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(requests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  if (loading) {
    return <p>Loading requests...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div>
      <Navbar />
      <center>
      <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>Manager Blacklist Requests</h3>
      </center>
      
      <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={handleSearch} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>
      <div className="table-container">

        <table className="responsive-table" id="documentTable">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {inProgressRequests.length > 0 ? (
              inProgressRequests.map((request) => (
                <tr key={request.id}>
                  <td>{request.Employee_Name}</td>
                  <td>{request.further_reason}</td>
                  <td>{request.manager_status  || "Pending"}</td>
                  <td style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
  <button
    onClick={() => handleApprove(request)}
    disabled={
      request.manager_status === "Approved" ||
      request.manager_status === "Rejected"
    }
    style={{
      backgroundColor:
        request.manager_status === "Approved" ||
        request.manager_status === "Rejected"
          ? "#ccc"
          : "#28a745",
      color: "white",
      border: "none",
      borderRadius: "5px",
      padding: "5px 10px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      cursor:
        request.manager_status === "Approved" ||
        request.manager_status === "Rejected" 
          ? "not-allowed"
          : "pointer",
    }}
  >
     <FaCheck /> Approve
    {/* {request.manager_status === "Approved" ? "Approved" : "Approve"} */}
  </button>

  <button
    onClick={() => {
      setSelectedRequest(request);
      setIsModalOpen(true);
    }}
    disabled={
      request.manager_status === "Rejected" ||
      request.manager_status === "Approved"
    }
    style={{
      backgroundColor:
        request.manager_status === "Approved" ||
        request.manager_status === "Rejected"
          ? "#ccc"
          : "#dc3545",
      color: "white",
      border: "none",
      borderRadius: "5px",
      padding: "5px 10px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      cursor:
        request.telecaller_status === "Approved" ||
        request.telecaller_status === "Rejected"
          ? "not-allowed"
          : "pointer",
    }}
  >
    <FaTimes />Reject
    {/* {request.manager_status === "Rejected" ? "Rejected" : "Reject"} */}
  </button>
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No "In Progress" requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {requests.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
      {/* Rejection Reason Modal */}
      {isModalOpen && (
        <div className="employee-modal-overlay">
           <div className="employee-modal">
           <h3 className="employee-modal-title">Provide Reason for Rejection</h3>
          <textarea
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder="Enter reason here"
            className="employee-input"
          ></textarea>
           <div className="employee-buttonContainer">
           <button onClick={handleReject} className=" employee-modal-btn  employee-primaryButton">Submit</button>
           <button onClick={() => setIsModalOpen(false)} className="employee-modal-btn  employee-secondaryButton">Cancel</button>
           </div>
          
           </div>

        </div>
      )}
    </div>
  );
};

export default ManagerBlacklistRequests;
